module.exports = "/_next/static/images/bg-phone-2x-9bc9700156a6c4b033dabf10e51eed2c.png.webp";